import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from './api';

const SubdomainAccess = () => {
  const { subdomain } = useParams(); // Get subdomain from the URL
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const checkSubdomainAccess = async () => {
      try {
        const response = await api.get(`/auth/subdomain/${subdomain}`);
        setMessage(response.data.message); // Subdomain is active
      } catch (err) {
        if (err.response?.status === 403) {
          setError(err.response.data.message); // Subdomain is disabled
        } else {
          setError('Failed to access subdomain. Please try again.');
        }
      }
    };

    checkSubdomainAccess();
  }, [subdomain]);

  if (error) {
    return <p style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>{error}</p>;
  }

  return <p style={{ textAlign: 'center', marginTop: '20px' }}>{message}</p>;
};

export default SubdomainAccess;